/**
 * @param {String} key
 * @param {*} value
 */
export function setItem (key, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}

/**
 * @param {String} key
 * @param {Boolean} asObj
 * @returns {*}
 */
export function getItem (key, asObj) {
  const item = window.localStorage.getItem(key)
  if (asObj) {
    return JSON.parse(item)
  }
  return item
}

/**
 * @param {String} key
 */
export function removeItem (key) {
  window.localStorage.removeItem(key)
}
